<div
    class="main-grid main-grid-template"
    [ngClass]="{
      'main-grid-easy': difficulty === 'EASY',
      'main-grid-medium': difficulty === 'MED',
      'main-grid-hard': difficulty === 'HARD',
      'main-grid-high-contrast': visualAccessibilityOn,
      'main-grid-template-high-contrast': visualAccessibilityOn,
      'text-color-blind': colorblindModeOn
    }">

  <!-- Score -->
  <div class="grid-target" id='score-and-lives-background' [ngStyle]="{'grid-area':'points-and-lives'}">

    <div
      class='score-group-left'
      [ngClass]="{'score-group-left-high-contrast': visualAccessibilityOn}"
      [ngStyle]="{
        'margin-top':'10px'
      }">
      <div [ngStyle]="{'display':'flex'}">
        <div>
          <p>{{score | scoreString}}</p>
          <p>Streak x {{streak}}</p>
        </div>
        <img *ngIf="streak > 0 && streak < 5" id="score-flame" src="./assets/images/UI/Flame_small_1.svg" alt="" [attr.aria-label]="'liekki_1' | ariaTranslate: uiLanguage">
        <img *ngIf="streak > 4 && streak < 13" id="score-flame" src="./assets/images/UI/Flame_Mid_1.svg" alt="" [attr.aria-label]="'liekki_2' | ariaTranslate: uiLanguage">
        <img *ngIf="streak > 12" id="score-flame" src="./assets/images/UI/Flame_Large_1.svg" alt="" [attr.aria-label]="'liekki_3' | ariaTranslate: uiLanguage">
      </div>
    </div>
    <div class="grid-target lives-group-left" [ngClass]="{'lives-group-left-high-contrast': visualAccessibilityOn}">

      <img class="life-indicator" [attr.aria-label]="'elama_1' | ariaTranslate: uiLanguage" src="{{lives > 2 ? './assets/images/UI/icon-heart_full.svg' : ''}}">
      <img class="life-indicator" [attr.aria-label]="'elama_2' | ariaTranslate: uiLanguage" src="{{lives > 1 ? './assets/images/UI/icon-heart_full.svg' : ''}}">
      <img class="life-indicator" [attr.aria-label]="'elama_3' | ariaTranslate: uiLanguage" src="{{lives > 0 ? './assets/images/UI/icon-heart_full.svg' : ''}}">

    </div>


  </div>

  <!-- Timer -->
  <div *ngIf="!noStressMode" class="grid-target" [ngStyle]="{'grid-area':'time'}">

    <img id="timer-clock" [attr.aria-label]="'kello' | ariaTranslate: uiLanguage" src="./assets/images/UI/Clock_1.svg">

    <p  id="timer-time">{{clockTime.minutes + ':' + clockTime.seconds}}</p>

  </div>

  <!-- Pause button -->

  <div class="grid-target" id='pause-area' [ngStyle]="{'grid-area':'pause'}">
    <button
      class='pause-button'
      [ngClass]="{'pause-button-high-contrast': visualAccessibilityOn}"
      (click)='OpenMenu()'
    >
      <img id="pause-image" [attr.aria-label]="'pause_nappula' | ariaTranslate: uiLanguage" src="./assets/images/UI/Pause_1.svg">
    </button>
    <p
      [ngStyle]="{'margin-left':'55px'}"
      *ngIf="keyboardControlOn">
      {{(keyboardControlOn ? '[P] ' : '')}}
    </p>
  </div>

  <!-- Question -->
  <div class="grid-target" [ngStyle]="{'grid-area':'question'}">

    <!-- QUESTION FOR EASY AND HARD -->
    <div
      *ngIf="difficulty != 'MED'"
      class='question-image-background'
      [ngClass]="{
        'question-image-background-high-contrast': visualAccessibilityOn,
        'question-image-background-color-blind': colorblindModeOn
      }"
    >
      <img
        class='question-image'
        [attr.aria-label]="currentQuestion.correctAnswer | ariaTranslate: uiLanguage : true"
        [ngClass]="{'question-image-high-contrast': visualAccessibilityOn}"
        src="{{'./assets/images/options/' + currentQuestion.correctAnswer.image}}">
    </div>

    <!-- QUESTION FOR MED -->
    <div *ngIf="difficulty == 'MED'">
      <p
        [ngClass]="{'question-high-contrast': visualAccessibilityOn}"
        [ngStyle]="{'max-width':'300px', 'text-align':'center'}">{{currentQuestion.correctAnswer|translate:false}}</p>
    </div>

  </div>

  <!-- Answer choices -->
  <div
    class="grid-target"
    [ngClass]="{
      'choices-high-contrast': visualAccessibilityOn
    }"
    [ngStyle]="{'grid-area':'choices'}">


    <!-- LAYOUT FOR EASY AND HARD -->
    <div *ngIf="difficulty != 'MED'" id="text-options">
      <button mat-button *ngFor="let choice of answerChoices; let i = index"
              [ngClass]="{
                          'answer-button': true,
                          'answer-button-high-contrast': visualAccessibilityOn,
                          'hard-option': difficulty == 'HARD' && !answerGiven,
                          'hard-option-high-contrast': difficulty == 'HARD' && !answerGiven && visualAccessibilityOn,
                          'correct-answer-reveal': answerGiven && choice.Equals(currentQuestion.correctAnswer) && (answer === null || !choice.Equals(answer)),
                          'correct-answer': answerGiven && choice.Equals(currentQuestion.correctAnswer) && answer !== null && choice.Equals(answer),
                          'wrong-answer': answerGiven && !choice.Equals(currentQuestion.correctAnswer) && answer !== null && choice.Equals(answer)
                        }"
              (click)="GiveAnswer(choice)"

      >
        <p *ngIf="!answerGiven">{{(keyboardControlOn ? '[' + (i+1) + '] ' : '') + (choice | translate:false)}}</p>
        <p *ngIf="answerGiven">{{choice | translate:false:learnLanguage:true}}</p>
      </button>
    </div>


  <!-- LAYOUT FOR MEDIUM -->
    <div *ngIf="difficulty == 'MED'" id="medium-options">

      <button mat-button *ngFor="let choice of answerChoices; index as i"
              class="medium-answer-option"
              [ngClass]="{
                          'answer-button': true,
                          'medium-answer-option-high-contrast': visualAccessibilityOn,
                          'correct-answer-reveal': answerGiven && choice.Equals(currentQuestion.correctAnswer) && (answer === null || !choice.Equals(answer)),
                          'correct-answer': answerGiven && choice.Equals(currentQuestion.correctAnswer) && answer !== null && choice.Equals(answer),
                          'wrong-answer': answerGiven && !choice.Equals(currentQuestion.correctAnswer) && answer !== null && choice.Equals(answer)
                        }"
              [ngStyle]="{'grid-area':'area'+(i+1)}"
              (click)="GiveAnswer(choice)"
      >
        <div [ngStyle]="{'height':'100%', 'width':'100%', 'display':'flex', 'flex-direction':'column', 'align-items':'center', 'justify-content':'center'}">
          <img
            *ngIf="!answerGiven"
            class="medium-answer-image"
            [attr.aria-label]="choice | ariaTranslate: uiLanguage : true"
            src="{{'./assets/images/options/' + choice.image}}">
          <p *ngIf="!answerGiven && keyboardControlOn">{{'[' + (i+1) + ']'}}</p>
          <p *ngIf="answerGiven">{{choice | translate:false:learnLanguage:true }}</p>
        </div>
      </button>
    </div>

  </div>

</div>


<!-- TUTORIAL POPUP -->
<app-popup-menu #tutorial>
  <div class='popup-content' [ngClass]="{'popup-content-high-contrast': visualAccessibilityOn}">

    <div *ngIf="!noStressMode" class='tutorial-row' [ngClass]="{'tutorial-row-high-contrast':visualAccessibilityOn}">
      <img
        class="tutorial-img"
        [attr.aria-label]="'tutoriaali_kello' | ariaTranslate: uiLanguage"
        [ngClass]="{'tutorial-img-high-contrast':visualAccessibilityOn}"
        src="./assets/images/UI/Clock_1.svg">
      <p
        class="tutorial-img-text"
        [attr.aria-label]="'tutoriaali_sydan' | ariaTranslate: uiLanguage"
        [ngClass]="{
          'tutorial-img-text-high-contrast':visualAccessibilityOn,
          'text-color-blind':colorblindModeOn
        }"
      >{{'tutorial_2'|translate}}</p>
    </div>

    <div class='tutorial-row' [ngClass]="{'tutorial-mid-row-high-contrast':visualAccessibilityOn}">
      <img
        class="tutorial-img"
        [ngClass]="{'tutorial-img-high-contrast':visualAccessibilityOn}"
        src="./assets/images/UI/icon-heart_full.svg">
      <p
        class="tutorial-img-text"
        [ngClass]="{
          'tutorial-img-text-high-contrast':visualAccessibilityOn,
          'text-color-blind':colorblindModeOn
        }"
      >{{'tutorial_3'|translate}}</p>
    </div>

    <p class='tutorial-text'
      [ngClass]="{
        'tutorial-text-high-contrast':visualAccessibilityOn,
        'text-color-blind':colorblindModeOn
      }"
      >
      {{'tutorial_1'|translate}}
    </p>

    <div
      class='tutorial-button-container'
      [ngClass]="{
        'tutorial-button-container-high-contrast':visualAccessibilityOn,
        'text-color-blind':colorblindModeOn
      }"
    >
      <button
        mat-button
        class='close-tutorial-button'
        [ngClass]="{'close-tutorial-button-high-contrast':visualAccessibilityOn}"
        (click)='CloseTutorial()'
      >{{(keyboardControlOn ? '[ENTER] ' : '') + ('start_game'|translate)}}!</button>
    </div>

  </div>
</app-popup-menu>


<!-- PAUSE POPUP -->
<app-popup-menu #pausePopup>
  <div class='popup-content'>

    <div class='pause-button-container'>
      <button mat-button class='pause-menu-button' (click)='CloseMenu()'>
        <img [attr.aria-label]="'unpause_nappula' | ariaTranslate: uiLanguage" src='./assets/images/UI/Replay_1.svg'>
      </button>
      <p *ngIf="keyboardControlOn">{{(keyboardControlOn ? '[P] ' : '')}}</p>

    </div>

    <div class='pause-button-container'>
      <button
        mat-button
        class='pause-menu-button'
        [ngClass]="{'text-color-blind': colorblindModeOn}"
        (click)='EndGame(true)'>
        <img [attr.aria-label]="'poistu_pelista_nappula' | ariaTranslate: uiLanguage" src='./assets/images/UI/Home_1.svg'>
      </button>
      <p *ngIf="keyboardControlOn">{{(keyboardControlOn ? '[ENTER] ' : '')}}</p>
    </div>

  </div>

</app-popup-menu>
